<ngx-mat-timepicker-face [color]="color"
                     [selectedTime]="selectedHour"
                     [faceTime]="hoursList"
                     [format]="format"
                     (timeChange)="hourChange.next($event)"
                     (timeSelected)="onTimeSelected($event)"></ngx-mat-timepicker-face>
